/**
 * Checks the width of the browser window to
 * determine whether it is a mobile device.
 *
 * @author Oleg Meglin <om@meglin.media>
 * @since  wpgenesis-theme 2.0.0
 *
 * @returns {boolean}
 */
export default function isMobile() {
  return window.innerWidth <= 767
}
